import { render, staticRenderFns } from "./Listas.vue?vue&type=template&id=5423e014&scoped=true"
import script from "./Listas.vue?vue&type=script&lang=js"
export * from "./Listas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423e014",
  null
  
)

export default component.exports